import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { alert } from 'devextreme/ui/dialog';
import * as moment from 'moment';
import { AppInformationService } from 'src/app/core/core.module';
import { Invoice } from 'src/app/core/data/entities';
import { PortalService } from 'src/app/core/data/portal.service';
import { StripeElementsOptions, StripePaymentElementOptions } from '@stripe/stripe-js';

import { injectStripe, StripePaymentElementComponent } from 'ngx-stripe';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-invoice',
    templateUrl: './invoice.component.html',
    styleUrls: ['./invoice.component.scss'],
    standalone: false
})
export class InvoiceComponent implements OnInit {
    invoice: Invoice;
    subTotal: number;
    nameOnCard: any;
    email: any;
    cardNumber: any;
    cvc: any;
    expirationMonth: any;
    expirationYear: any;
    expirationYears: any[] = [];
    notValid = false;
    validationMessage = '';
    invoiceCode: any;
    processing = false;

    // stripe = injectStripe('pk_test_51I9N1mK8Kf5gNeZbMclfbGeyPTc15DzWKd9spYnMlm01vGIT0nGxaxtitms0fq0uXuBtuMoJ0qkcpRVKM1A5Vkim00mM2Iw9CZ') as any;
    stripe = injectStripe(environment.stripe_pk_key as string) as any;
    cardElement;
    elements;

    constructor(private portalService: PortalService, private activatedRoute: ActivatedRoute, private router: Router, private appInfo: AppInformationService) {}

    async ngOnInit() {
        this.activatedRoute.queryParams.subscribe((params) => {
            this.invoiceCode = params['code'];
        });
        await this.getData();
        if (!this.invoice) return;
        this.calcInvoiceSubTotal();

        const options = {
            mode: 'payment',
            currency: 'usd',
            amount: this.invoice.total * 100
        };

        //Don't generate stripe elements if the invoice is already paid - DOM error
        if (!this.invoice.paid) {
            this.elements = await this.stripe.elements(options).toPromise();

            //setting the name and email to never allows us to have our own inputs for this information.  It needs to be
            //passed to the confirmPayment call and cannot be null
            const paymentOptions = {
                fields: {
                    billingDetails: {
                        name: 'never',
                        email: 'never',
                        phone: 'auto',
                        address: {
                            line1: 'auto',
                            line2: 'auto',
                            city: 'auto',
                            state: 'auto',
                            country: 'auto',
                            postalCode: 'auto'
                        }
                    }
                }
            };
            this.cardElement = this.elements.create('payment', paymentOptions);
            this.cardElement.mount('#payment-element');
        }
    }

    async getData() {
        const data = (await this.portalService.getInvoice(this.invoiceCode)) as Invoice;
        if (data) {
            this.invoice = data;
        }
    }

    calcInvoiceSubTotal() {
        this.subTotal = this.invoice.total - this.invoice.tax;
    }

    async payment() {
        if (!this.validate() || !!this.invoice.paid) return;
        this.processing = true;
        this.appInfo.pleaseWaitShow();

        // Trigger form validation and wallet collection
        const submitError = await this.elements.submit();
        if (submitError.error) {
            // console.log('submitError', submitError);
            this.appInfo.pleaseWaitHide();
            await alert(`Your payment was NOT successfully processed.`, `${this.appInfo.settings.company}`);
            this.processing = false;
            return;
        }

        //Create the paymentIntent on the server to tokenize the credit card information
        const intentData = (await this.portalService.createPaymentIntent(this.invoiceCode)) as any;
        const clientSecret = intentData.client_secret;
        // console.log('intentData', intentData);
        if (!clientSecret) {
            this.appInfo.pleaseWaitHide();
            await alert(`Your payment was NOT successfully processed.  Failed to create PaymentIntent.  Contact system administrator`, `${this.appInfo.settings.company}`);
            this.processing = false;
            return;
        }

        // Use the clientSecret and Elements instance to confirm the setup
        const confirmPayment = await this.stripe
            .confirmPayment({
                elements: this.elements,
                clientSecret,
                confirmParams: {
                    payment_method_data: {
                        billing_details: {
                            name: this.nameOnCard,
                            email: this.email
                        }
                    },
                    return_url: 'https://example.com/order/123/complete'
                },
                // Uncomment below if you only want redirect for redirect-based payments
                redirect: 'if_required'
            })
            .toPromise();
        console.log('confirmPayment', confirmPayment);

        if (confirmPayment.error) {
            this.appInfo.pleaseWaitHide();
            await alert(`Your payment was NOT successfully processed. ${confirmPayment.error.message}`, `${this.appInfo.settings.company}`);
            this.processing = false;
            return;
        }

        if (confirmPayment.paymentIntent.status === 'succeeded') {
            //Save confirmPaymentId and invoice
            const savePayment = (await this.portalService.markedAsPaid(this.invoiceCode, JSON.stringify(confirmPayment.paymentIntent))) as any;
            this.appInfo.pleaseWaitHide();
            await alert('Your payment was successfully processed.', 'Payment Successful');
            this.appInfo.pleaseWaitShow();
            await this.getData();
            this.appInfo.pleaseWaitHide();
        }
        this.processing = false;
    }

    validate() {
        if (!this.nameOnCard || this.nameOnCard.trim().length === 0) {
            this.validationMessage = 'Name is required';
            this.notValid = true;
            return false;
        } else if (!this.email || this.email.trim().length === 0) {
            this.validationMessage = 'Email is required';
            this.notValid = true;
            return false;
        } else if (!!this.email && this.email.indexOf('@') < 0) {
            this.validationMessage = 'Email is invalid';
            this.notValid = true;
            return false;
        }
        this.notValid = false;
        return true;
    }
}
